export default {
  language: 'Language',
  common: {
    cancel: 'Cancel',
    fieldEmpty: 'This field cannot be empty.',
    loading: 'Loading...',
    username: 'Username',
    password: 'Password',
    rpassword: 'Repeat Password',
    mobile: 'Mobile Number',
    email: 'Email',
    login: 'Log in',
    signup: 'Sign Up',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    continue: 'Continue',
    close: 'Close',
    leg: 'Leg',
    getFee: 'GET fee',
    get: 'GET',
    serviceFee: 'Service Fee',
    militaryClearance: 'Military Clearance',
    endDateMust: 'End date must be later than start date.',
    maxDurationCharter: 'Max duration for charter booking is {time}.',
    invalidDateRange: 'Invalid date range.',
    fieldRequired: 'The {field} field is required.',
    invalidEmail: 'The email field must be a valid email.'
  },
  searchForm: {
    bookARide: 'Book a Ride',
    bookACharter: 'Book a Charter By The Hour',
    requestARide: 'Request a ride now',
    bookCharter: 'Book a charter service',
    enterPickup: 'Enter your pickup location:',
    extraStop: 'Extra Stop:',
    enterDropoff: 'Enter your dropoff location:',
    whenDoYou: 'When do you need a ride?',
    untilWhen: 'Until when do you need it?',
    getAQuote: 'Get a Quote',
    gettingQuote: 'Getting quote...',
    editCancel: 'Edit/Cancel Your Ride',
    editRsvp: 'Edit Reservation',
    trackVehicle: 'Track Your Vehicle',
    trackRsvp: 'Track Reservation',
    or: 'or',
    haveCorporate: 'Do you have a corporate account?',
    loginSignup: 'Login/Signup here',
    not: 'Not',
    signout: 'Sign out',
    youAreLogged: 'You are logged in as personal account.',
    locationPlaceholder: 'e.g. Airport, Home etc.',
    startDateGreater: 'Start Date must be greater than {WebTimeBuffer} minutes from current time.',
    manualPickup: 'Manual pickup location text input is not precise enough',
    unablePinpointPickup: 'Unable to pinpoint your desired pickup location.',
    manualLocation: 'Manual location text input is not precise enough',
    unablePinpointExtra: 'Unable to pinpoint your desired extra stop location.',
    manualDropoff: 'Manual dropoff location text input is not precise enough',
    unablePinpointDropoff: 'Unable to pinpoint your desired dropoff location.',
    noAvailableService: 'No Available Service Type',
    sorryService: 'Sorry! Our services are not yet available in this area.',
    youCanAdd: 'You can add an additional stop.',
    airports: 'Airports',
    themeParks: 'Theme Parks',
    ports: 'Ports',
    hotel: 'Hotels',
    universities: 'Universities',
    setMap: 'Set on Map',
    map: 'Map',
    setLocation: 'Set Location',
    sorry: 'Sorry',
    coudntLocate: 'We coudn\'t locate',
    pleaseFillForm: 'Please fill in this form to create an account',
    recommendedSize: 'Recommended Size:',
    corporateName: 'Corporate Name',
    website: 'Website',
    billingInfo: 'Billing Information',
    creditCard: 'Credit Card #',
    cardName: 'Cardholder Name',
    exp: 'Expiration',
    cvv: 'cvv',
    addr: 'Address',
    addr1: 'Address1',
    addr2: 'Address2',
    city: 'City',
    state: 'State',
    nonUs: 'Non US',
    zip: 'Zip Code',
    country: 'Country',
    reviewDetails: 'Review your details',
    submitting: 'Submitting. Please wait...',
    thankYouSignup: 'Thank you for signing up!',
    yourCorporate: 'Your corporate profile is awaiting approval by the administrator. You will receive a notice once your account has been approved.',
    ok: 'OK',
    pleaseUpload: 'Please upload an image.',
    spaceNotAllowed: 'Space is not allowed',
    validEmail: 'Please input valid email address.',
    passwordNotMatch: 'Password and Repeat password doesn\'t match.',
    uploadImgFail: 'Uploading image fail. Please try again.',
    serviceNA: 'Services Not Available',

    d2dFlight: 'Door-to-door Flight',
    departure: 'Departure',
    travellers: 'Travelers',
    selectDeparture: 'Select Departure Date',
    howManyTravelling: 'How many are you travelling with?'
  },
  serviceSelect: {
    changeSelect: 'See More Service Options',
    future: 'In the Future',
    rightNow: 'Right Now',
    selectAsap: 'Select this option if you want to be picked up as soon as possible.',
    dateAsapLyft: 'Extra Stops are not available for ASAP rides and will be removed automatically.',
    pickAsap: 'Pick me up ASAP',
    selectStartDate: 'Select a Start Date:',
    selectEndDate: 'Select an End Date:',
    selectPickupDate: 'Select a Pickup Date:',
    flightArrival: 'Flight Arrival Date',
    flightDeparture: 'Flight Departure Date',
    selectStartTime: 'Select a Start Time:',
    selectEndTime: 'Select an End Time:',
    selectPickupTime: 'Select a Pickup Time:',
    arrivalTime: 'Select your Flight Arrival Time',
    departureTime: 'Select your Flight Departure Time',
    mustBe: 'Must be at least {pickuptimeRule} from now',
    apply: 'Apply',
    useSuggested: 'Use Suggested Time',
    timeBufferError1: 'Selected Time must be greater than {webTimeBuffer} minutes from current time.',
    timeBufferError2: 'Flight {direction} time must not be set in the past',
    endDateMust: 'End date must be later than start date.',
    chooseAirline: 'Choose an airline from the list',
    chooseFlight: 'Choose a flight from the list',
    thisDomestic: 'This is a domestic flight',
    cantFindFlight: 'Click here to enter your flight no.',
    typeFlight: 'Type in flight no.',
    search: 'Search',
    provideFlight: 'Please provide your flight no.',
    rideDetails: '1. Your Ride Details',
    selectService: '2. Select A Service',
    clickImage: 'Click image for larger view',
    dontWantRT: 'I don\'t want to book a round trip.',
    rtDetails: '3. Round Trip Details',
    isNotAvailable: 'is not available on your return trip date. Please try to either switch to another service or change your return trip date.',
    chooseService: '4. Choose A Service',
    returnLater: 'Returning Later?',
    bookRt: 'Book a Return Trip',
    suggestedPickupTime: 'Suggested Pickup Time',
    firstTrip: 'for your first trip',
    toMakeSurePickup: 'To make sure we can pick you up as soon as you arrive at the airport, here\'s your suggested pickup time:',
    toMakeSureFlight: 'To make sure that you don\'t miss your flight, your suggested pickup time is:',
    yesSuggested: 'Yes, use the suggested pickup time.',
    noKeep: 'No, I want to keep my pickup time.',
    suggestedPickupTimeReturn: 'Suggested Pickup Time for your return trip',
    wereSorry: 'We\'re sorry, but we don\'t have any rides available for the date and time you selected.',
    legErrorFields: 'Leg{leg}: Please fill in all require fields!',
    pleaseSelectService: 'Please select a service.',
    legSelectService: 'Leg{leg}: Please select a service.',
    availableOnlyFrom: 'Available only from',
    save: 'Save',
    bySharingRide: 'by sharing your ride.',
    ifWeFind: 'If we find at least 1 other person to share your ride with, we will refund you',
    atTheTime: 'at the time your trip is completed.',
    iWantTo: 'I want to share my ride with someone else',
    startDate: 'Start Date',
    endDate: 'End Date',
    flightArrive: 'When will your flight arrive?',
    flightDepart: 'When will your flight depart?',
    whenRide: 'When do you need a ride?',
    flightInfo: 'Flight Information',
    pax: 'Passengers',
    choose: 'Choose',
    luggage: 'Check-in Luggage',
    carryOns: 'Includes carry-ons',
    aptGate: 'Apartment/Gate #',
    optional: '(optional)',
    arrivalTimes: 'Arrival Times provided are only estimates based on the current traffic data.',
    forReturnTrip: '*For your return trip, you will be picked up on',
    scheduled: 'Scheduled',
    scheduledAsap: 'Scheduled or ASAP',
    selectFlightTime: 'Please set a flight time first.',
    inputFlightNo: 'Please select or input flight no.',
    bestValue: 'Best Value',
    fastest: 'Fastest',
    plusApplicableFees: 'Plus applicable fees',
    onewayFare: 'One-way fare',
    serviceAirportAvailable1: '{service} service is only available at the airport from {start} to {end}.',
    serviceAirportAvailable2: '{service} service is currently not available for airport pickup.',
    tryService: 'Please try our <b>{service}</b> service',
    discount: 'Discount:',
    minutesAway: 'minute(s) away',
    pickupDate: 'Pickup Date:',
    dropoffTime: '*Drop Off: ',
    bookAdvance: 'Book in advance',
    mng: 'Meet and Greet',
    complimentary: 'Complimentary',
    viewMoreImgs: 'View more images',
    moreInfo: 'More Info',
    hideInfo: 'Hide Info',
    plusAppFees: 'Plus applicable fees',
    oneWayFare: 'One-way fare',
    downstairs: 'DOWNSTAIRS',
    upstairs: 'UPSTAIRS',
    advantage: 'Advantage',
    stops: 'Stops',
    NA: 'Not Available',
    availableFrom: 'Available from',
    availableUntil: 'Available until',
    daysLeft: 'day(s) left',
    timeLeft: 'time left',
    tryService2: 'Try our {service} service',
    wouldYouLike: 'Would you like to try <b>{service}</b> instead?',
    yesChoose: 'Yes, Choose {service}',
    pickup: 'Pickup',
    extraStop: 'Extra Stop',
    dropoff: 'Dropoff',
    sharedNotAllowed: 'Shared service is not allowed on booking with Extra Stop.',
    noService: 'No service available.',
    noSelectedService: 'No selected service.',
    pickupTimeMustBe: 'Pickup time must be after {time}.'
  },
  customerForm: {
    yourInfo: 'Your Information',
    emailExist: 'The email already exists in our system. If you have a password associated with the provided email, please',
    clickHere: 'click here',
    toSignIn: 'to sign-in',
    otherwisePlease: 'Otherwise, please provide the phone number you used for your previous booking.',
    firstName: 'First Name',
    lastName: 'Last Name',
    iHaveWheelchair: 'I have a wheelchair.',
    iHaveServiceDog: 'I have a service dog.',
    previous: 'Previous',
    serviceSelection: 'Service Selection',
    paymentDetails: 'Payment Details',
    signIn: 'Sign In',
    enterEmail: 'Enter the email address associated with your account, and we’ll email you a link to reset your password.',
    sendReset: 'Send Reset Password',
    bookForSomeone: 'I\'m not the passenger. I\'m booking this for someone else.',
    paxInfo: 'Passenger Information',
    not: 'Not',
    signOut: 'Sign out',
    alreadyHave: 'Already have an account?',
    signIn2: 'Sign-in',
    emailUsername: 'Email or Username',
    forgotPass: 'Forgot Password?',
    corporateAccnt: 'Corporate Account',
    createAccnt: 'Create me an account so I don’t have to repeat this next time.',
    passwordRequired: 'The password field is required.',
    passwordNotMatch: 'Password does not match.',
    confirmEmail: 'Confirm Email'
  },
  driverReview: {
    thankYou: 'Thank you for riding with us!',
    ok: 'OK',
    thankYouRating: 'Thank you for rating this trip!',
    feedback: 'Your feedback will help us improve to serve you better.',
    poor: 'Poor',
    fair: 'Fair',
    average: 'Average',
    good: 'Good',
    execellent: 'Excellent!',
    rateRide: 'Rate Your Ride',
    writeComments: 'Write your comments, compliments, or suggestions here...'
  },
  global: {
    verify: 'Verify',
    verified: 'Verified',
    changePhone: 'Change Phone number',
    textPin: 'A text message has been sent with a 4-digit pin number. Please enter the pin in the field below.',
    pin: 'Pin',
    loading: 'Loading',
    resendPin: 'Resend Pin',
    fieldRequired: 'This field is required.',
    verifyFirst: 'You need to verify mobile first in order to proceed.',
    oops: 'Oops! Something went wrong. Please try again.',
    invalidPin: 'Invalid verification pin.',
    dropoffEstimate: '* Drop-off time is an estimate based on the current traffic data.'
  },
  payment: {
    payment: 'Payment',
    cardEncrypt: 'Card information are encrypted, secure, and protected.',
    selectCard: 'Please select a card to use',
    directBill: 'Direct Billing',
    useNew: 'Use a New Credit Card',
    selectPayment: 'Please select a payment method.',
    availablePayment: 'Available Payment Methods',
    nameOnCard: 'Name on Card',
    isRequired: 'This is required.',
    cardNumber: 'Card Number',
    exp: 'Expiration Date',
    securityCode: 'Security Code',
    for: 'For',
    digitCard1: 'the 3 digits on the <i>back</i> of your card.',
    digitCard2: 'the 4 digits on the <i>front</i> of your card.',
    billingAddr: 'Billing Address',
    city: 'City',
    state: 'State',
    chooseOne: 'Choose one',
    zip: 'Zip',
    country: 'Country',
    previous: 'Previous',
    yourInfo: 'Your Information',
    validating: 'Validating...',
    reviewBook: 'Review and Book',
    followFormat: 'Please follow the format',
    invalidExp: 'Invalid expiration month.',
    futureDate: 'Please enter a future date.',
    fare: 'Fare',
    airportFee: 'Airport Fee:',
    fuelSurcharge: 'Fuel Surcharge',
    mng: 'Meet & Greet:',
    tip: 'Tip',
    credits: 'Credits:',
    redeem: 'Redeem',
    total: 'Total:',
    riderFee: 'Rider Fee',
    addTip: 'Add Tip',
    changeTip: 'Change Tip',
    enterTip: 'Enter your tip.',
    promoCode: 'Promo Code',
    leg: 'Leg',
    custom: 'Custom'
  },
  rsvpDetails: {
    hideTrip: 'Hide Trip Summary',
    showTrip: 'Show Trip Summary',
    tripSummary: 'Trip Summary',
    serviceType: 'Service Type',
    pickupType: 'Pickup Type ',
    edit: 'EDIT',
    startDate: 'Start Date',
    pickupDate: 'Pickup Date',
    endDate: 'End Date',
    driverNotes: 'Driver Notes',
    aptGate: 'Apt/Gate',
    flight: 'Flight',
    curbside: 'Curbside',
    mng: 'Meet & Greet',
    complimentary: 'Complimentary',
    pickup: 'Pick Up',
    extraStop: 'Extra Stop',
    dropoff: 'Drop Off',
    inputNotes: 'Input driver notes'
  },
  review: {
    findingRide: 'Finding your ride',
    lookNearby: 'Looking for nearby drivers',
    busyDrivers: 'Looks like our drivers are busy. Trying again in',
    sendingTo: 'Sending to',
    checking: 'Checking',
    sending: 'Sending',
    yourRequest: 'your request',
    foundDriver: 'We found you a driver!',
    driverOTW: 'The driver is on its way.',
    trackTrip: 'TRACK YOUR TRIP',
    close: 'close',
    oops: 'Oops, something went wrong. Please try again later.',
    goBack: 'Go Back',
    creditCard: 'Credit Card',
    clickPay: 'By clicking the Pay button, you are agreeing to our',
    tos: 'Terms of Service',
    sendEmail: 'We will send a confirmation email to',
    submittingRsvp: 'Submitting Reservation',
    currentlySubmitting: 'We are currently submitting your reservation.',
    dontRefresh: 'Please don\'t leave or refresh this page.',
    shouldntTake: 'This shouldn\'t take long.',
    successBooked: 'You have successfully booked your reservation!',
    tyRsvp: 'Thank you for booking a reservation with us.',
    weSentEmail: 'We have sent the confirmation email to',
    safelyClose: 'You can now safely close this page or go back to our website by clicking',
    thisLink: 'this link',
    unfortunately: 'Unfortunately, we were not able to process the payment for your return trip. You can try again and book your return trip separately.',
    subscribed: 'Successfully subscribed to our mailing list.',
    subscribeMailing: 'Subscribe to our mailing list to receive exclusive offers and discounts.',
    subscribeNow: 'SUBSCRIBE NOW',
    reviewBook: 'Review and Book',
    yourRsvp1: 'Here\'s your Reservation Number',
    yourRsvp2: 'Here are your Reservation Numbers',
    pay: 'Pay'
  },
  searchEdit: {
    editCancel: 'Edit/Cancel Your Reservation',
    followInfo: 'Please enter the following information to proceed',
    isRequired: 'This is required.',
    cannotFind: 'Cannot find your reservation.',
    rsvpCompleted: 'Your reservation is already completed.',
    rsvpCancelled: 'Your reservation is already cancelled.',
    cannotEdit: 'You cannot edit your reservation because your driver is already on the way to pick you up.',
    onboard: 'You cannot edit your reservation because you\'re already on-board.',
    rsvpDoesntExist: 'That reservation does not exist. Please check the information you provided and try again.',
    unassign: 'Unassign Driver',
    alreadyAssigned: 'Your reservation is already assigned to a driver. In order to edit your reservation, we need to unassign it from the driver first.',
    confirmUnassign: 'Do you want to unassign the driver and continue with editing your reservation?',
    yes: 'Yes I do.',
    no: 'No, I don\'t want to.',
    unassigning: 'Unassigning Driver',
    rsvpNumber: 'Reservation Number',
    firstName: 'First Name',
    lastName: 'Last Name'
  },
  searchTrack: {
    trackVehicle: 'Track your Vehicle',
    followInfo: 'Please enter the following information to proceed',
    isRequired: 'This is required.',
    rsvpCompleted: 'Your reservation is already completed.',
    rsvpCancelled: 'Your reservation is already cancelled.',
    rsvpDoesntExist: 'That reservation does not exist. Please check the information you provided and try again.',
    rsvpNumber: 'Reservation Number',
    firstName: 'First Name',
    lastName: 'Last Name'
  },
  rsvpEdit: {
    convertCredit: 'You have the option to convert this ride into a Ride Credit.',
    convertDesc1: 'By doing so, your account will be credited ',
    convertDesc2: 'which you can use to book ',
    convertDesc3: 'reservations anytime you need a ride.',
    cxlFeeWillApply: 'Cancellation fees will apply.',
    confirmConvert: 'Would you like to convert this into a Ride Credit?',
    yes: 'Yes, I do.',
    no: 'No, I want to cancel this ride.',
    confirmCancel: 'Confirm Cancellation',
    whyCancel: 'Please tell us why you want to cancel this reservation:',
    chooseOne: 'Choose one.',
    provideReason: 'Please provide a reason for your cancellation.',
    yesCancel: 'Yes, Cancel my Reservation',
    noCancel: 'No, I changed my mind.',
    cancelRsvp: 'Cancelling Reservation...',
    rsvp: 'Reservation',
    creditSuccess: 'was credited successfully.',
    cancelSuccess: 'Successfully cancelled reservation.',
    ok: 'Ok, got it.',
    oops: 'Oops something went wrong.',
    tryAgain: 'Try again later.',
    reason1: 'I booked this by mistake',
    reason2: 'I\'m not happy with the price',
    reason3: 'I\'m not happy with the service',
    reason4: 'My plans changed',
    reason5: 'My driver had a bad attitude',
    reason6: 'Duplicate reservation',
    reason7: 'My driver was late for the pickup',
    reason8: 'My driver did not arrive',
    reason9: 'I took an Uber',
    reason10: 'I took a Lyft',
    reason11: 'I took a cab',
    reason12: 'Other',
    cancelRsvp2: 'Are you sure you want to cancel your reservation?',
    chargeAmount: 'You will be charged a <b>$</b><strong>{amount}</strong> cancellation fee when you cancel this reservation.<br/>Do you want to proceed?',
    custInfo: 'Customer Information',
    name: 'Name',
    phone: 'Phone',
    selectStartDate: 'Select a Start Date:',
    selectEndDate: 'Select a End Date:',
    pickupDate: 'Select a Pickup Date:',
    arrivalDate: 'Select your Flight Arrival Date',
    departureDate: 'Select your Flight Departure Date',
    selectStartTime: 'Select a Start Time:',
    selectEndTime: 'Select an End Time:',
    arrivalTime: 'Select your Flight Arrival Time',
    departureTime: 'Select your Flight Departure Time',
    pickupTime: 'Select a Pickup Time:',
    setEndTime: 'Set End Time',
    setTime: 'Set Pickup Time',
    applyTime: 'Apply Time',
    buffer1: 'Pickup time must be at least',
    buffer2: 'minutes ahead.',
    EndDateMust: 'End date must be later than start date.',
    maxDurationFor: 'Max duration for charter booking is {time}.',
    invalidDateRange: 'Invalid date range.',
    driverNotes: 'Note to Driver',
    saveNote: 'Save Note',
    removeNote: 'Remove Note',
    emptyNotes: 'Notes must not be empty',
    chooseAirline: 'Choose an airline from the list:',
    chooseFlight: 'Choose your flight from the list',
    cantFindFlight: 'I can\'t find my flight on the list.',
    fieldRequired: 'This field is required.',
    domesticFlight: 'This is a domestic flight',
    lookingFor: 'Looking for',
    flights: 'flights',
    whoBooking: 'Who are you booking this for?',
    save: 'SAVE',
    bookForMyself: 'I\'m booking this for myself.',
    nameRequired: 'First Name and Last Name fields are required.',
    editingRsvp: 'Editing Reservation',
    rsvpDetails: 'Reservation Details',
    pickupLoc: 'Pickup Location',
    addExtraStop: 'Add Extra Stop',
    extraStop: 'Extra Stop',
    dropoffLoc: 'Dropoff Location',
    pickupTime2: 'Pickup Time',
    UntilWhen: 'Until when do you need a ride?',
    flightInfo: 'Flight Information',
    enterFlight: 'Enter Your Flight Information',
    pax: 'Passengers',
    luggage: 'Luggage',
    serviceType: 'Service Type',
    saveBySharing: 'Save {percent}% by sharing your ride.',
    ifWeFind: 'If we find at least 1 other person to share your ride with, we will refund you',
    atTheTime: 'at the time your trip is completed.',
    iWantToShare: 'I want to share my ride with someone else',
    pickupType: 'Pickup Type',
    mng: 'Meet & Greet',
    complimentary: 'Complimentary',
    guestInfo: 'Guest Information',
    wheelchair: 'Wheelchair',
    yes2: 'Yes',
    no2: 'No',
    serviceDog: 'Service Dog',
    driverNote: 'Driver Note',
    updateRsvp: 'Update My Reservation',
    cancelRsvp3: 'Cancel My Reservation',
    returnHome: 'Return to Home Page',
    missedSomething: 'Looks like you missed something.',
    gotIt: 'OK, I got it.',
    suggestedPickupTime: 'Suggested Pickup Time',
    suggesteDesc: 'To make sure we can pick you up as soon as you arrive at the airport, here\'s your suggested pickup time:',
    suggesteDesc2: 'To make sure that you don\'t miss your flight, your suggested pickup time is:',
    suggestedYes: 'Yes, use the suggested pickup time.',
    suggestedNo: 'No, I want to keep my pickup time.',
    bookingForMyself: 'I\'m booking this for myself',
    bookingFor: 'Booking for',
    addDriverNote: 'Add a note for your driver.',
    terminal: 'Terminal',
    provideFlightInfo: 'Please provide your flight information to continue.',
    noServiceSelected: 'No service selected.',
    serviceAccomodate1: 'The service you selected cannot accommodate',
    serviceAccomodate2: 'passengers.<br/>Please select a different service type to continue.',
    serviceAccomodate3: 'luggage.<br/>Please select a different service type to continue.',
    pickupTimeMust: 'Pickup time must be at least {buffer} minutes ahead.',
    pleaseSetEnd: 'Please set your end date.',
    typeLocation: 'Type in your {location} location.',
    removeExtraStop: 'Remove Extra Stop',
    extraStop2: 'extra stop',
    pickup: 'pickup',
    dropoff: 'dropoff',
    pickupLocation: 'Pickup Location',
    dropoffLocation: 'Dropoff Location',
    sorry: 'Sorry',
    couldntLocate: 'We coudn\'t locate',
    paymentInfo: 'Payment Information',
    ccUsed: 'Credit Card Used:',
    paidThru: 'Paid thru other means.',
    fare: 'Fare:',
    airportFee: 'Airport Fee:',
    fuelSurcharge: 'Fuel Surcharge:',
    tip: 'Tip:',
    creditUsed: 'Credits Used:',
    total: 'Total:',
    travelInsu: 'Travel Insurance',
    startDate: 'Start Date',
    pickupDate2: 'Pickup Date',
    availableOnlyFrom: 'Available only from ',
    chooseService: 'Choose a Service:',
    doYouWant: 'Do you want to share your ride with someone else?',
    yesIWantToShare: 'Yes, I want to share my ride with someone else',
    noThanks: 'No, Thanks.',
    NA: 'Not Available',
    availableFrom: 'Available from',
    availableUntil: 'Available until',
    tryOur: 'Try our',
    service: 'service',
    serviceAvailable: 'service is only available at the airport from',
    to: 'to',
    serviceAirportPickup: 'service is currently not available for airport pickup.',
    wouldYouLike: 'Would you like to try',
    instead: 'instead?',
    yes3: 'Yes, Choose',
    changePickupTime: 'I will change the pickup time',
    confirmUpdate: 'Confirm Update',
    updateRsvp2: 'Are you sure you want to update your reservation?',
    yesUpdate: 'Update My Reservation',
    updatingRsvpp: 'Updating Reservation...',
    successUpdate: 'Successfully updated reservation.',
    okUpdate: 'Ok, got it.',
    failUpdate: 'Unable to update your reservation. We are unable to process your payment information.',
    dueCharged: 'Due to the changes you made to your reservation, you will be charged an additional',
    yourCard: 'to your credit card.',
    dueRefund: 'Due to the changes you made to your reservation, you will be refunded',
    typeNote: 'Type a note here',
    search: 'Search...',
    typeFlight: 'Type in your flight number.',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    forRsvpInfo: 'For reservation info updates, please cancel this reservation and book again.',
    riderFee: 'Rider Fee',
    selectDatePast: 'Selected date must not be in the past.',
    pickupTimeMustBeAfter: 'Pickup time must be after {time}.'
  },
  rsvpTrack: {
    rsvpDetails: 'Reservation Details',
    pickupLoc: 'Pickup Location',
    extraStop: 'Extra Stop',
    dropoffLock: 'Dropoff Location',
    pickupTime: 'Pickup Time',
    endTime: 'End Time',
    flightInfo: 'Flight Information',
    noFlightInfo: 'No Flight Information',
    pax: 'Passengers',
    luggage: 'Luggage',
    serviceType: 'Service Type',
    pickupType: 'Pickup Type',
    mng: 'Meet & Greet',
    guestInfo: 'Guest Information',
    wheelchair: 'Wheelchair',
    yes: 'Yes',
    no: 'No',
    serviceDog: 'Service Dog',
    driverNote: 'Driver Note',
    bookForMyself: 'I\'m booking this for myself',
    bookFor: 'Booking for',
    noDriverNotes: 'No Driver Notes.',
    terminal: 'Terminal',
    eta: 'Estimated Arrival Time:',
    yourDriver: 'Your Driver',
    noDriverYet: 'Looks like you don\'t have a driver yet.',
    driverCheckAgain: 'Please check it again one (1) hour before your pickup time.',
    phone: 'Phone Number:',
    email: 'Email Address:',
    driverLicense: 'Driver\'s License No.:',
    bestExp: 'To get the best experience, download the {brandName} mobile app using the buttons below.',
    appStore: 'App Store',
    playStore: 'Play Store',
    trackRsvp: 'Tracking Reservation',
    returnHome: 'Return to Home Page'
  },
  events: {
    sentPassword: 'We sent you a password recovery email',
    invalidPromo: 'Invalid promo code.',
    successRedeem: 'Successfully redeemed',
    invalidDiscount: 'The code you entered is not valid.',
    expiredDiscount: 'Expired Code: The code you entered has expired.'
  },
  progressbar: {
    chooseRide: 'Choose your Ride',
    enterDetails: 'Enter your Details',
    paymentDetails: 'Payment Details',
    reviewBook: 'Review and Book'
  },
  backend: {
    "There is no service available": "There is no service available.",
    "Out of coverage area": "Out of coverage area",
    "1.0 Cannot create stripe profile": "1.0 Cannot create stripe profile",
    "1.0 Cannot updated customer profile": "1.0 Cannot updated customer profile",
    "1.1 Cannot create stripe profile": "1.1 Cannot create stripe profile",
    "1.1 Cannot update customer profile": "1.1 Cannot update customer profile",
    "403 Forbidden": "403 Forbidden",
    "A KML File is required to activate this geofence": "A KML File is required to activate this geofence",
    "A credit card is required": "A credit card is required",
    "Account is disabled": "Account is disabled",
    "Action unauthorized for non-drivers": "Action unauthorized for non-drivers",
    "Attempting to { list: [] } a non-array": "Attempting to { list: [] } a non-array",
    "Attempting to { list: [], paging: {} } a non-array": "Attempting to { list: [], paging: {} } a non-array",
    "Authentication error. Account may have been logged in on another device": "Authentication error. Account may have been logged in on another device.",
    "Authentication error. Invalid token": "Authentication error. Invalid token.",
    "Authentication error": "Authentication error.",
    "Bid has already been accepted": "Bid has already been accepted",
    "Bid has already been cancelled": "Bid has already been cancelled",
    "Brand is required for quotation": "Brand is required for quotation",
    "Brand is required": "Brand is required",
    "Cannot determine pricing": "Cannot determine pricing",
    "Cannot display brand": "Cannot display brand",
    "Cannot find admins": "Cannot find admins",
    "Cannot find ads": "Cannot find ads",
    "Cannot find driver": "Cannot find driver",
    "Cannot find driver's services": "Cannot find driver's services",
    "Cannot find driver's vehicle": "Cannot find driver's vehicle",
    "Cannot find external account for this provider": "Cannot find external account for this provider.",
    "Cannot find phone numbers": "Cannot find phone numbers",
    "Cannot find subgeofences": "Cannot find subgeofences",
    "Cannot get geofence list": "Cannot get geofence list",
    "Cannot get tracks list": "Cannot get tracks list",
    "Cannot refresh invoice information": "Cannot refresh invoice information",
    "Cant get consumer connection": "Cant get consumer connection",
    "Cant get consumer login": "Cant get consumer login",
    "Card not found": "Card not found",
    "Catd not found": "Catd not found",
    "Cons Auth": "Cons Auth",
    "Consumer account is disabled": "Consumer account is disabled",
    "Consumer card not available": "Consumer card not available",
    "Corporate Username already exists": "Corporate Username already exists",
    "Corporate account is disabled": "Corporate account is disabled",
    "Corporate device not found": "Corporate device not found",
    "Corporate profile is not associated with a customer account": "Corporate profile is not associated with a customer account",
    "Corporate profile is not linked to a customer account": "Corporate profile is not linked to a customer account",
    "Corporate profile not found": "Corporate profile not found",
    "Credit card cannot be found anymore": "Credit card cannot be found anymore",
    "Date range is required to filter": "Date range is required to filter",
    "Destination account not found 1": "Destination account not found 1",
    "Dispatch view requires [since]": "Dispatch view requires [since]",
    "Dispatch view requires [until]": "Dispatch view requires [until]",
    "Driver cannot accept shared packages": "Driver cannot accept shared packages",
    "Driver cannot accept this service type": "Driver cannot accept this service type",
    "Driver does not have availability at the reservation's time": "Driver does not have availability at the reservation's time",
    "Driver is not TNC": "Driver is not TNC",
    "Driver is not on duty": "Driver is not on duty",
    "Driver not subscribed to notifications": "Driver not subscribed to notifications",
    "Dropoff is required for quotation": "Dropoff is required for quotation",
    "Dropoff location out of coverage area": "Dropoff location out of coverage area",
    "ERR_EDIT_RESTRICTED', 'Reservation cannot be edited anymore": "ERR_EDIT_RESTRICTED', 'Reservation cannot be edited anymore",
    "ERR_RESTRICTED_GEOFENCE', 'You cannot view available reservations on a restricted area": "ERR_RESTRICTED_GEOFENCE', 'You cannot view available reservations on a restricted area",
    "E_CANNOT_LOGIN": "E_CANNOT_LOGIN",
    "E_EMAIL_EXISTS": "E_EMAIL_EXISTS",
    "Error finding corporate device": "Error finding corporate device",
    "Error finding corporate profile": "Error finding corporate profile",
    "Error finding corporate token": "Error finding corporate token",
    "Error trying to find corporate account": "Error trying to find corporate account",
    "Failed to create invoice": "Failed to create invoice",
    "First Name is required": "First Name is required",
    "Forbidden to view this reservation": "Forbidden to view this reservation",
    "Forbidden": "Forbidden",
    "Invalid charge amount": "Invalid charge amount",
    "Invalid corporate account": "Invalid corporate account",
    "Invalid corporate profile": "Invalid corporate profile",
    "Invalid corporate token": "Invalid corporate token",
    "Invalid fare matrix. Please contact administrator": "Invalid fare matrix. Please contact administrator.",
    "Invalid package": "Invalid package",
    "Invalid password recovery token": "Invalid password recovery token",
    "Invalid payment calculation!!": "Invalid payment calculation!!",
    "Invalid payment calculation!": "Invalid payment calculation!",
    "Invalid payment calculation": "Invalid payment calculation",
    "Invalid pickup time": "Invalid pickup time",
    "Invalid reservation": "Invalid reservation",
    "Invalid reset password key": "Invalid reset password key",
    "Invalid token": "Invalid token.",
    "Invoice not found": "Invoice not found",
    "Last Name is required": "Last Name is required",
    "Mobile Phone is required": "Mobile Phone is required",
    "No card that can be charged using stripe": "No card that can be charged using stripe",
    "No currently running ad": "No currently running ad",
    "No drivers to send": "No drivers to send",
    "No ongoing reservation": "No ongoing reservation",
    "No payment options selected": "No payment options selected",
    "No phone number": "No phone number",
    "No services available": "No services available",
    "No vehicles found for driver": "No vehicles found for driver",
    "Not allowed": "Not allowed",
    "Notes are required when cancelling reservation": "Notes are required when cancelling reservation",
    "Notification token is required": "Notification token is required",
    "Only transport drivers are allowed at the moment": "Only transport drivers are allowed at the moment",
    "Package does not contain any reservations": "Package does not contain any reservations",
    "Package geofence does not support TCP": "Package geofence does not support TCP",
    "Package geofence does not support TNC": "Package geofence does not support TNC",
    "Package has already been accepted by a driver": "Package has already been accepted by a driver.",
    "Package is currently under auto-package": "Package is currently under auto-package.",
    "Parameter [amount] is required": "Parameter [amount] is required",
    "Parameter [cancel] must be true or false only": "Parameter [cancel] must be true or false only",
    "Parameter [chargeFees] must be true or false only": "Parameter [chargeFees] must be true or false only",
    "Parameters [contactID] must be an array": "Parameters [contactID] must be an array",
    "Part of the packages to be merged are already assigned to a driver": "Part of the packages to be merged are already assigned to a driver",
    "Part of the reservations are already assigned to a driver": "Part of the reservations are already assigned to a driver",
    "Password is required": "Password is required",
    "Phone number already exists": "Phone number already exists",
    "Pickup is required for quotation": "Pickup is required for quotation",
    "Pickup location out of coverage area": "Pickup location out of coverage area",
    "Please enable your location tracking to be able to start trip": "Please enable your location tracking to be able to start trip",
    "Please enter a valid tip": "Please enter a valid tip",
    "Please leave a note when marking an RSVP as complete": "Please leave a note when marking an RSVP as complete",
    "Requires lat": "Requires lat",
    "Requires lng": "Requires lng",
    "Requires radius": "Requires radius",
    "Requires since parameter": "Requires since parameter",
    "Requires until parameter": "Requires until parameter",
    "Reservation has already been reviewed": "Reservation has already been reviewed",
    "Reservation is not accepted by any provider yet": "Reservation is not accepted by any provider yet",
    "Reservation is not scheduled to this time": "Reservation is not scheduled to this time",
    "Reservation is not yet complete": "Reservation is not yet complete",
    "Reservation is not yet completed": "Reservation is not yet completed",
    "Reservation not found": "Reservation not found",
    "Schedule assigned to other driver": "Schedule assigned to other driver",
    "Schedule is not available anymore": "Schedule is not available anymore",
    "Schedule items not found": "Schedule items not found",
    "Schedule not found": "Schedule not found",
    "Sector not created": "Sector not created",
    "Sector not found": "Sector not found",
    "Services unavailable": "Services unavailable",
    "Shift not created": "Shift not created",
    "Shift not found": "Shift not found",
    "Subsector not created": "Subsector not created",
    "Subsector not found": "Subsector not found",
    "The reservation has already been canceled": "The reservation has already been canceled",
    "There is another reservation scheduled now": "There is another reservation scheduled now",
    "This geofence does not support ASAP trips": "This geofence does not support ASAP trips",
    "This geofence does not support future reservations": "This geofence does not support future reservations",
    "This provider has no account yet": "This provider has no account yet.",
    "This reservation is not paid through other means": "This reservation is not paid through other means",
    "Tip has already been given beforehand": "Tip has already been given beforehand",
    "Token is required": "Token is required",
    "Transaction has already been refunded": "Transaction has already been refunded",
    "Trip is currently under auto-dispatch": "Trip is currently under auto-dispatch.",
    "Trip is not available anymore": "Trip is not available anymore.",
    "Trip requires military clearance": "Trip requires military clearance.",
    "Trip requires service dog": "Trip requires service dog.",
    "Trip requires wheelchair lift": "Trip requires wheelchair lift.",
    "Unable to break a package that is already assigned to a driver": "Unable to break a package that is already assigned to a driver",
    "Unable to charge the card": "Unable to charge the card",
    "Unable to charge the card. No ID": "Unable to charge the card. No ID.",
    "Unable to charge the card. No result": "Unable to charge the card. No result.",
    "Unable to check for invoice date conflicts": "Unable to check for invoice date conflicts",
    "Unable to create profile info": "Unable to create profile info",
    "Unable to deduct credits": "Unable to deduct credits",
    "Unable to determine dropoff geofence": "Unable to determine dropoff geofence",
    "Unable to determine pickup geofence": "Unable to determine pickup geofence",
    "Unable to edit reservation of another brand": "Unable to edit reservation of another brand",
    "Unable to fetch driver list without business": "Unable to fetch driver list without business",
    "Unable to fetch drivers without business": "Unable to fetch drivers without business",
    "Unable to fetch import record": "Unable to fetch import record",
    "Unable to fetch pickup types": "Unable to fetch pickup types",
    "Unable to fetch pricing": "Unable to fetch pricing",
    "Unable to fetch services": "Unable to fetch services",
    "Unable to find address for this provider": "Unable to find address for this provider",
    "Unable to find airport association": "Unable to find airport association",
    "Unable to find directions": "Unable to find directions",
    "Unable to find directions for the specified pickup and dropoff": "Unable to find directions for the specified pickup and dropoff",
    "Unable to find dropoff geofences": "Unable to find dropoff geofences",
    "Unable to find filter": "Unable to find filter",
    "Unable to find list of transactions": "Unable to find list of transactions",
    "Unable to find phone number for this provider": "Unable to find phone number for this provider",
    "Unable to find pickup geofences": "Unable to find pickup geofences",
    "Unable to find sector": "Unable to find sector",
    "Unable to find shift": "Unable to find shift",
    "Unable to find subsector": "Unable to find subsector",
    "Unable to get autodispatch logs": "Unable to get autodispatch logs",
    "Unable to get autodispatch triggers": "Unable to get autodispatch triggers",
    "Unable to get credit card list": "Unable to get credit card list",
    "Unable to get nearby drivers": "Unable to get nearby drivers",
    "Unable to get vehicle for provider": "Unable to get vehicle for provider",
    "Unable to get your location": "Unable to get your location.",
    "Unable to mark as arrived, current location is not yet near the pickup": "Unable to mark as arrived, current location is not yet near the pickup",
    "Unable to mark as complete, current location is not yet near the dropoff": "Unable to mark as complete, current location is not yet near the dropoff",
    "Unable to use the credit card selected": "Unable to use the credit card selected",
    "Unauthorized": "Unauthorized",
    "Unknown charge identifier": "Unknown charge identifier",
    "Unknown payout status 2": "Unknown payout status 2",
    "Unknown payout status 3": "Unknown payout status 3",
    "Unknown payout status": "Unknown payout status",
    "Unknown reservation": "Unknown reservation",
    "Unknown trx ID": "Unknown trx ID",
    "User not found": "User not found",
    "Username already exists": "Username already exists",
    "Username is required": "Username is required",
    "Vehicle cannot accommodate a military clearance": "Vehicle cannot accommodate a military clearance",
    "Vehicle cannot accommodate a service dog": "Vehicle cannot accommodate a service dog",
    "Vehicle is not equipped with wheelchair lift": "Vehicle is not equipped with wheelchair lift",
    "You can only start this trip once you are in the staging area": "You can only start this trip once you are in the staging area",
    "Your driver account is not active. Action is restricted": "Your driver account is not active. Action is restricted.",
    "[driverId] is required": "[driverId] is required",
    "[geofenceId] needs to be passed as an array": "[geofenceId] needs to be passed as an array",
    "[props] is required": "[props] is required",
    "[services] is required": "[services] is required",
    "[services] needs to be an array": "[services] needs to be an array",
    "cannot find drivers": "cannot find drivers",
    "cannot find provider": "cannot find provider",
    "cannot find staging lots": "cannot find staging lots",
    "cannot get provider's enabled services": "cannot get provider's enabled services",
    "cannot get staging lot queue": "cannot get staging lot queue",
    "flight not found": "flight not found",
    "gg": "gg",
    "invalid consumer id": "invalid consumer id",
    "no consumer to notify": "no consumer to notify",
    "no location": "no location",
    "not found": "not found",
    "package items required": "package items required",
    "requires ID": "requires ID",
    "rsvp not found": "rsvp not found",
    "rsvpId is required": "rsvpId is required.",
    "Expired password recovery key": "Expired password recovery key",
    "Charter service is not available for this area": "Charter service is not available for this area",
    "Invalid email/password": 'Invalid email/password',
    "Invalid promo code": 'Invalid promo code.',
    "This promo code is only valid for new users": 'This promo code is only valid for new users.',
    "Promo already expired": 'Promo already expired',
    "Payment method for this reservation is no longer available": "Payment method for this reservation is no longer available",
    "Phone already in use. Please log in or reset your password": "Phone already in use. Please log in or reset your password."
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js